import React, { FC, useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { INIT_PAGE_INFO } from 'services/utils/constants';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { actions } from 'containers/ActiveCloudResource/slice';
import { SubComponentContainer } from 'containers/Compliance/Components/ComplianceTables/SubComponentContainer';

interface Props {
  row: any;
}

export const ProcessConnections: FC<Props> = ({ row }) => {
  const { processConnections } = useSelector(selectActiveResource);
  const dispatch = useDispatch();
  const getProcessConnections = useCallback(
    (pageInfo = INIT_PAGE_INFO) => {
      dispatch(
        actions.getProcessConnections({
          q: {
            connection_type: row?.connection_type!,
            agent_id: row?.agent_id,
            container_id: row?.container_id!,
            src_process_name: row?.name,
            page: pageInfo.page_number,
            page_size: pageInfo.page_size,
          },
        }),
      );
    },
    [dispatch, row],
  );

  useEffect(() => {
    getProcessConnections();
  }, [getProcessConnections]);

  const subColumns = [
    {
      header: 'Source IP',
      accessor: 'src_ip_addr',
    },
    {
      header: 'Source Port',
      accessor: 'src_port',
    },
    {
      header: 'Destination IP',
      accessor: 'dst_ip_addr',
    },
    {
      header: 'Destination Port',
      accessor: 'dst_port',
    },
    {
      header: 'Protocol',
      accessor: 'protocol',
    },
    {
      header: 'Encrypted',
      render: ({ row }) => (row?.encrypted ? 'Yes' : 'No'),
    },
  ];

  return (
    <SubComponentContainer>
      <Table
        columns={subColumns}
        data={
          processConnections[
            row?.connection_type + '_' + row?.agent_id + '_' + row?.name
          ]?.data ?? []
        }
        isLoading={
          processConnections[
            row?.connection_type + '_' + row?.agent_id + '_' + row?.name
          ]?.isLoading
        }
      />
    </SubComponentContainer>
  );
};
